interface AssigneeCardProps {
  name: string;
  role?: string;
  avatarColor?: string;
}

export default function AssigneeCard({
  name,
  role,
  avatarColor = "#6d0016",
}: AssigneeCardProps) {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: avatarColor }}
      >
        <span className="font-montserrat font-semibold text-white" style={{ fontSize: "14px" }}>
          {name[0]}
        </span>
      </div>
      <div>
        <p className="font-montserrat font-medium text-stone-700" style={{ fontSize: "15px" }}>
          {name}
        </p>
        {role && (
          <p
            className="font-montserrat text-stone-500"
            style={{ fontSize: "14px", letterSpacing: "0.05em" }}
          >
            {role}
          </p>
        )}
      </div>
    </div>
  );
}
